import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { SoilUseGroupService } from '../proxy/planning/controllers/soil-use-group.service';

FieldBuilder.setNamespace('Planning');

export const SOILUSE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.SoilUse.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .foreignKey('soilUseGroupId', 'Entity.SoilUseGroup', SoilUseGroupService)
    .required()
    .displayFromNested('soilUseGroup.name')
    .sortBy('soilUseGroup.name')
    .build(),
];

export const SOILUSE_CONFIG = {
  entityName: 'SoilUse',
  localizationKey: 'Planning::Entity.SoilUse',
  fields: SOILUSE_FIELDS,
  permission: 'PlanningOperation.SoilUses',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.OperationPlanning + MENU_NAME_SUFFIX,
};
